export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "bg_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const saveToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });
